import { render, staticRenderFns } from "./ReportMessage.vue?vue&type=template&id=350130ce&scoped=true&"
import script from "./ReportMessage.vue?vue&type=script&lang=js&"
export * from "./ReportMessage.vue?vue&type=script&lang=js&"
import style0 from "./ReportMessage.vue?vue&type=style&index=0&id=350130ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350130ce",
  null
  
)

export default component.exports